/**
 * Страница активации устройства через токен
 */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDeviceStore } from '../store/deviceStore'
import { apiClient } from '../services/apiClient'
import { DeviceRegistrationService } from '../services/deviceRegistrationService'
import './ActivationPage.css'

export function ActivationPage() {
  const navigate = useNavigate()
  const { token } = useParams<{ token: string }>()
  const deviceStore = useDeviceStore()
  const [status, setStatus] = useState<'checking' | 'activating' | 'success' | 'error'>('checking')
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    // Проверяем установлено ли PWA
    // Приоритет: 1) Native kiosk bridge, 2) PWA display-mode, 3) iOS standalone
    const isPWAInstalled = 
      !!(window as any).AndroidKiosk?.isStandalone?.() ||  // Native kiosk wrapper
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches ||
      (window.navigator as any).standalone === true

    // Если PWA НЕ установлено - редирект на install
    if (!isPWAInstalled) {
      console.log('[ActivationPage] PWA not installed, redirecting to install page')
      navigate(`/install?token=${token}`, { replace: true })
      return
    }

    // Если PWA установлено - вызываем API активации
    const activateDevice = async () => {
      try {
        setStatus('activating')
        
        const deviceId = deviceStore.deviceId
        if (!deviceId) {
          throw new Error('Device ID not found')
        }

        const deviceFingerprint = DeviceRegistrationService.getDeviceFingerprint()
        
        console.log('[ActivationPage] Activating device with token:', token)
        
        // Вызываем API активации
        await apiClient.post('/tablet/register/activate', {
          token: token?.toUpperCase(),
          device_id: deviceId,
          device_fingerprint: deviceFingerprint,
          user_agent: navigator.userAgent
        })
        
        console.log('[ActivationPage] Activation request sent, redirecting to waiting page')
        setStatus('success')
        
        // Сохраняем токен для отображения на странице ожидания
        if (token) {
          localStorage.setItem('activationToken', token.toUpperCase())
        }
        
        // Переход на страницу ожидания подтверждения с токеном
        setTimeout(() => {
          navigate(`/waiting-approval?token=${token?.toUpperCase()}`, { replace: true })
        }, 1500)
        
      } catch (error: any) {
        console.error('[ActivationPage] Activation failed:', error)
        setStatus('error')
        
        if (error.response?.data?.detail) {
          setErrorMessage(error.response.data.detail)
        } else if (error.message) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Не удалось активировать устройство. Проверьте токен и попробуйте снова.')
        }
      }
    }
    
    activateDevice()
  }, [token, deviceStore.deviceId, navigate])

  return (
    <div className="activation-page">
      <div className="activation-card">
        {status === 'checking' && (
          <>
            <div className="activation-loader"></div>
            <h2>Проверка установки...</h2>
            <p>Проверяем установлено ли приложение</p>
          </>
        )}

        {status === 'activating' && (
          <>
            <div className="activation-loader"></div>
            <h2>Активация устройства</h2>
            <p>Отправляем запрос на регистрацию</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="activation-icon success-icon">✅</div>
            <h2>Успешно!</h2>
            <p>Запрос отправлен. Ожидайте подтверждения администратора.</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="activation-icon error-icon">❌</div>
            <h2>Ошибка активации</h2>
            {errorMessage && (
              <div className="error-message">
                {errorMessage}
              </div>
            )}
            <div className="activation-actions">
              <button 
                className="activation-button primary"
                onClick={() => window.location.reload()}
              >
                Попробовать снова
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
